import 'isomorphic-fetch';
import { getConfigurationByEnv } from '../configs/maintenance-configs';

export async function fetchApiConfig(baseUrl?: string): Promise<string> {
  const configJson = getConfigurationByEnv(baseUrl);
  const response = await fetch(`${configJson.url}/apiConfig`);
  if (!response.ok) {
    throw new Error('Failed to fetch API key');
  }

  const data = await response.json();
  const decodedString = atob(data.base64Encoded);
  const appConfig = JSON.parse(decodedString);

  configJson.apiKey = appConfig;

  return appConfig;
}
